<template>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">INVENTORY</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 inventory-page">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="d-flex align-items-center">
              <h2 class="me-3">Stock Transfers</h2>
              <material-button
                class="btn btn-sm btn-background"
                @click="createStockTransfer()"
                style="height: 34.5px"
              >
                <i class="material-icons css-icon">addoutlined</i>
                Create
              </material-button>
            </div>
            <FormSearch
              :openAddItemModal="createStockTransfer"
              :isStockTransfer="true"
              @reset-filters="handleResetFilters"
              :total="total"
              :total_low_on_stock="total_in_transit"
              :total_exceeded_high_stock="total_completed"
              @export="exportFile"
              :get-list="getList"
            />
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-left font-weight-bolder"></th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-left font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-3"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                                <div v-if="item.hasFilter" class="dropdown" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); z-index: 10;">
                                  <i
                                    class="material-icons filter-icon"
                                    :id="`filterDropdown-${index + 1}`"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    :style="{
                                      cursor: 'pointer',
                                      fontSize: '18px',
                                      color: isColumnFiltered('field', item.field, null) ? '#007bff' : '#BABBBD'
                                    }"
                                  >
                                    filter_list
                                  </i>
                                  <ul
                                    class="dropdown-menu px-2"
                                    :aria-labelledby="`filterDropdown-${index + 1}`"
                                  >
                                    <div class="dropdown-header">Filter by {{ item.label }}</div>
                                    <li class="mb-1">
                                      <select
                                        :value="getFilterOperator(`field_${item.field}`)"
                                        @input="setFilterOperator(`field_${item.field}`, $event.target.value)"
                                        class="form-select"
                                        style="padding: 5px; border: 1px solid #ced4da;"
                                      >
                                        <option value="" disabled>--- Select Operator ---</option>
                                        <option value="equal">Is equal to</option>
                                        <option value="less_than">Is less than</option>
                                        <option value="greater_than">Is greater than</option>
                                        <option value="contains">Contains</option>
                                      </select>
                                    </li>
                                    <li class="my-2">
                                      <input
                                        :value="getFilterValue(`field_${item.field}`)"
                                        @input="setFilterValue(`field_${item.field}`, $event.target.value)"
                                        type="text"
                                        class="w-100 p-1"
                                        placeholder="Enter value"
                                        style="border-radius: 0.375rem; border: 1px solid #ced4da; outline: none;"
                                      >
                                    </li>
                                    <li class="d-flex justify-content-center mt-3">
                                      <button
                                        class="btn btn-primary mx-auto"
                                        style="margin-bottom: 0.5rem;"
                                        @click="applyColumnFilter('field', item.field, null)"
                                      >
                                        Apply
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody style="height: 180px;">
                          <tr v-for="(value, key) in stockTransfers" :key="key">
                            <td class="text-center text-xss w-5">
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i
                                  class="material-icons cursor-pointer expand-toggle"
                                  aria-hidden="true"
                                  @click="toggleExpand($event, value)"
                                  >{{
                                    expandedRows.includes(value.id)
                                      ? "remove"
                                      : "add"
                                  }}</i
                                >
                              </div>
                            </td>
                            <td
                              class="text-left text-xss w-15 cursor-pointer"
                              @click="viewStockTransferDetail(value)"
                            >
                              {{ value?.doc_no }}
                            </td>
                            <td class="text-left text-xss w-20">
                              {{ value?.from }}
                            </td>
                            <td class="text-left text-xss w-20">
                              {{ value?.to }}
                            </td>
                            <td class="text-left text-xss w-15">
                              {{ value?.transfer_date }}
                            </td>
                            <td
                              class="text-left text-xss font-weight-bold w-15"
                            >
                              {{ value?.stock_action_label }}
                            </td>
                            <td
                              class="text-left text-xss font-weight-bold w-10"
                              :style="{ color: value?.status_color ?? '#000' }"
                            >
                              {{ value?.status_label }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <AddItemModal
        :keyReload="keyReloadAddItem"
        :isEditItem="isEditItem"
        :isInventoryItem="true"
        @reload-list-category="getList"
      ></AddItemModal>
      <ModalConfirm :message="textConfirm" :process-yes="receiveStock" />
      <ModalItemList
        :keyReload="keyReloadStockTransferDetail"
        :stockTransferDetail="stockTransferDetail"
        :editStockTransfer="editStockTransfer"
        :changeType="changeType"
        :exportFile="exportFileTransferDetail"
      />
    </div>
    <form
      :action="`${actionDownload}/merchant/inventory/stock-transfer/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="status" :value="status" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>

    <form
      :action="`${actionDownload}/merchant/inventory/stock-transfer-detail/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="stock_transfer_detail" :value="JSON.stringify(stockTransferDetail)" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input id="downloadFormTransferDetail" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import InventoryService from "../../services/inventory.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import "datatables.net";
import Pagination from "@/components/Pagination.vue";
import AddItemModal from "@/components/AddItem.vue";
import { STATUS_COMPLETED, STATUS_IN_TRANSIT, STATUS_VOID } from "./mock_data";
import MaterialButton from "@/components/MaterialButton.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalItemList from "./components/ModalItemList.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import Modal from "bootstrap/js/dist/modal";

export default {
  name: "inventory-stock-transfer",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    AddItemModal,
    MaterialButton,
    ModalConfirm,
    ModalItemList,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      stockTransfers: null,
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      dataTable: null,
      columnSearch: [],
      pagination: {},
      page: 1,
      keyReloadAddItem: "keyReloadAddItem",
      isEditItem: 0,
      status: null,
      timeType: null,
      total: 0,
      total_completed: 0,
      total_in_transit: 0,
      stockTransferDetail: null,
      keyReloadStockTransferDetail: "keyReloadStockTransferDetail",
      textConfirm: "Confirm to add stock to receiving branch?",
      type: "receive",
      STATUS_VOID: STATUS_VOID,
      STATUS_IN_TRANSIT: STATUS_IN_TRANSIT,
      STATUS_COMPLETED: STATUS_COMPLETED,
      columnFilters: {},
      activeColumnFilter: null,
      expandedRows: [],
    };
  },
  computed: {
    headersData() {
      return [
        {
          label: "Doc No",
          field: "doc_no",
          hasSortBy: false,
          hasFilter: true,
        },
        {
          label: "From",
          field: "from",
          hasSortBy: false,
          hasFilter: true,
        },
        {
          label: "To",
          field: "to",
          hasSortBy: false,
          hasFilter: true,
        },
        {
          label: "Transfer At",
          field: "transfer_date_sort",
          hasSortBy: true,
          hasFilter: false,
        },
        {
          label: "Action",
          field: "stock_action_label",
          hasSortBy: false,
          hasFilter: true,
        },
        {
          label: "Status",
          field: "status_label",
          hasSortBy: false,
          hasFilter: false,
        },
      ];
    },
  },
  mounted() {
    this.getList(this.page);
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 });
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    exportFileTransferDetail(type = "csv") {
      this.action_export = type;
      setTimeout(() => {
        $("#downloadFormTransferDetail").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }

      this.dataTable = $(this.$refs.dataTable).DataTable({
        paging: false,
        searching: true,
        ordering: false,
        info: false,
      });
    },

    searchColumn(index) {
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    handleChangeSortColumn(idx, field) {
      if (this.dataTable) {
        this.dataTable.rows().every(function () {
          if (this.child.isShown()) this.child.hide();
          return true;
        });
      }
      this.expandedRows = [];

      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;

      this.stockTransfers.sort(function (item, item2) {
        if (direction == "asc") {
          if (item[field] > item2[field]) return 1;
          if (item[field] < item2[field]) return -1;
        }

        if (direction == "desc") {
          if (item[field] < item2[field]) return 1;
          if (item[field] > item2[field]) return -1;
        }

        return 0;
      });
    },

    getList(page, status = null, timeType = null) {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.showLoader();
      var dataForm = {
        page: page,
      };

      if ([0, 1, 2, 3].includes(timeType)) {
        dataForm.time_type = timeType;
        this.timeType = timeType;
      } else {
        dataForm.time_type = this.timeType;
      }

      if ([STATUS_COMPLETED, STATUS_IN_TRANSIT].includes(status)) {
        this.status = status;
        dataForm.status = status;
      } else {
        this.status = null;
      }

      // Add column filters - only one filter at a time
      if (this.activeColumnFilter && this.activeColumnFilter.operator && this.activeColumnFilter.value) {
        if (this.activeColumnFilter.type === 'field') {
          dataForm.filters = {
            field: this.activeColumnFilter.field,
            operator: this.activeColumnFilter.operator,
            value: this.activeColumnFilter.value,
          };
        }
      }

      InventoryService.getStockTransfer(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.stockTransfers = data.data.items;
            this.expandedRows = [];
            this.pagination = data.data;
            this.page = this.pagination.current_page;

            this.total = data.total;
            this.total_completed = data.total_completed;
            this.total_in_transit = data.total_in_transit;

            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    viewStockTransferDetail(value) {
      this.stockTransferDetail = value;
      this.keyReloadStockTransferDetail = Math.random().toString();
      $(".btn-show-stock-transfer-detail-modal").click();
    },

    toggleExpand(event, value) {
      if (!this.dataTable) return;
      const tr = event.currentTarget.closest("tr");
      const row = this.dataTable.row(tr);
      if (row.child.isShown()) {
        row.child.hide();
        const idx = this.expandedRows.indexOf(value.id);
        if (idx !== -1) this.expandedRows.splice(idx, 1);
      } else {
        row.child(this.buildChildRow(value)).show();
        this.expandedRows.push(value.id);
        $(row.child())
          .find(".btn-duplicate-child")
          .on("click", () => {
            this.editStockTransfer(value.id, value.stock_action, true);
          });
      }
    },

    escapeHtml(str) {
      if (str === null || str === undefined) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    buildChildRow(value) {
      const items = value.stock_transfer_items || [];
      let bodyRows;
      if (items.length) {
        bodyRows = items
          .map(
            (item) => `
              <tr>
                <td class="text-left text-xss w-20">${this.escapeHtml(
                  item?.item?.item_no
                )}</td>
                <td class="text-left text-xss w-15">${this.escapeHtml(
                  item?.item?.barcode
                )}</td>
                <td class="text-left text-xss w-35">${this.escapeHtml(
                  item?.item?.item_name
                )}</td>
                <td class="text-left text-xss w-15">${this.escapeHtml(
                  this.formatPrice(item?.unit_cost)
                )}</td>
                <td class="text-left text-xss w-15">${this.escapeHtml(
                  item?.qty
                )}</td>
              </tr>`
          )
          .join("");
      } else {
        bodyRows = `<tr><td colspan="5" class="text-center">No item available</td></tr>`;
      }

      return `
        <div class="stock-transfer-child p-3">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-left font-weight-bolder">Item No</th>
                <th class="text-left font-weight-bolder">Barcode</th>
                <th class="text-left font-weight-bolder">Item Name</th>
                <th class="text-left font-weight-bolder">Unit Cost</th>
                <th class="text-left font-weight-bolder">Qty</th>
              </tr>
            </thead>
            <tbody>${bodyRows}</tbody>
          </table>
          <div class="d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-sm btn-background btn-duplicate-child mb-0"
            >
              Duplicate
            </button>
          </div>
        </div>`;
    },

    confirmReceiveStock(value, type) {
      this.stockTransferDetail = value;
      this.type = type;
      this.textConfirm =
        type == "void"
          ? "This will cancel the stock transfer, revert all stock impact."
          : "Confirm to add stock to receiving branch?";
      $(".btn-confirm-modal").click();
    },

    changeType(type) {
      this.type = type;
      this.textConfirm =
        type == "void"
          ? "This will cancel the stock transfer, revert all stock impact."
          : "Confirm to add stock to receiving branch?";
      this.showConfirmModal();
    },

    showConfirmModal() {
      const overlay = document.getElementById("custom-overlay");
      overlay?.classList.add("show");
      const modalElement = document.getElementById("modalConfirm");
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
        modalElement.addEventListener("hidden.bs.modal", () => {
          overlay?.classList.remove("show");
        });
      }
    },

    receiveStock() {
      $(".btn-hide-stock-transfer-detail-modal").click();
      $(".btn-close-modal").click();
      this.showLoader();

      let dataForm = {
        merchantId: this.$route.params.merchant_id,
        stock_transfer_id: this.stockTransferDetail.id,
      };

      if (this.type == "receive") {
        dataForm.physical_branch_id = this.stockTransferDetail.physical_branch_id;

        InventoryService.receiveStockTransfer(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Stock transfer received successful";
              this.setTimeOutNotification();
              this.getList(this.page);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      } else if (this.type == "void") {
        InventoryService.voidStockTransfer(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Stock transfer voided successful";
              this.setTimeOutNotification();
              this.getList(this.page);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    createStockTransfer() {
      this.$router.push({ name: "StockTransfer" });
    },

    editStockTransfer(id, action, isCopy = false) {
      this.$router.push({
        name: action == 0 ? "StockTransfer" : "StockInOut",
        params: { id: id },
        ...(isCopy ? { query: { copy: true } } : {}),
      });
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    getFilterOperator(key) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      return this.columnFilters[key].operator || '';
    },

    setFilterOperator(key, value) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      this.columnFilters[key].operator = value;
    },

    getFilterValue(key) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      return this.columnFilters[key].value || '';
    },

    setFilterValue(key, value) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      this.columnFilters[key].value = value;
    },

    isColumnFiltered(type, field, branchId) {
      if (!this.activeColumnFilter) {
        return false;
      }

      if (type === 'physical_branch') {
        return (
          this.activeColumnFilter.type === 'physical_branch' &&
          this.activeColumnFilter.branchId === branchId &&
          this.activeColumnFilter.operator &&
          this.activeColumnFilter.value
        );
      } else {
        return (
          this.activeColumnFilter.type === 'field' &&
          this.activeColumnFilter.field === field &&
          this.activeColumnFilter.operator &&
          this.activeColumnFilter.value
        );
      }
    },

    applyColumnFilter(type, field, branchId) {
      let filterKey;
      if (type === 'physical_branch') {
        filterKey = `physical_${branchId}`;
      } else {
        filterKey = `field_${field}`;
      }

      const filter = this.columnFilters[filterKey];
      if (!filter || !filter.operator || !filter.value) {
        return;
      }

      // Store the filter with type and field/branchId info
      this.columnFilters[filterKey].type = type;
      this.columnFilters[filterKey].field = field;
      this.columnFilters[filterKey].branchId = branchId;

      // Store active filter
      this.activeColumnFilter = {
        type: type,
        field: field,
        branchId: branchId,
        operator: filter.operator,
        value: filter.value,
      };

      // Close dropdown by removing show class
      this.$nextTick(() => {
        const $ = window.$;
        if ($) {
          if (type === 'physical_branch') {
            $(`#filterDropdown-physical-${branchId}`).parent().removeClass('show');
            $(`.dropdown-menu[aria-labelledby="filterDropdown-physical-${branchId}"]`).removeClass('show');
            $(`#filterDropdown-physical-${branchId}`).attr('aria-expanded', 'false');
          } else {
            const headerIndex = this.headersData.findIndex(h => h.field === field);
            if (headerIndex !== -1) {
              $(`#filterDropdown-${headerIndex + 1}`).parent().removeClass('show');
              $(`.dropdown-menu[aria-labelledby="filterDropdown-${headerIndex + 1}"]`).removeClass('show');
              $(`#filterDropdown-${headerIndex + 1}`).attr('aria-expanded', 'false');
            }
          }
        }
      });

      // Call API with filters
      this.getList(this.page, this.status, this.timeType);
    },

    handleResetFilters() {
      // Clear all filters
      this.activeColumnFilter = null;
      this.timeType = null;
      this.columnFilters = {};

      // Clear DataTable column search if DataTable is initialized
      if (this.dataTable) {
        const totalColumn = this.headersData.length;
        for (let i = 1; i <= totalColumn; i++) {
          this.dataTable.column(i).search("").draw();
        }
      }

      // Clear column search inputs
      this.columnSearch = [];

      // Reset to page 1 and call getList without pushing params to URL
      this.page = 1;
      this.getList(1, this.status, this.timeType);
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.initializeDataTable();
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

.expand-toggle {
  font-size: 20px;
  color: #67748e;
  line-height: 1;
  user-select: none;
}

.custom-table :deep(.stock-transfer-child) {
  background: #f0f6ff;
}

.dropdownMenuButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 30px;
}

.dropdown-item {
  display: flex;
  align-items: center;
}

.css-icon {
  position: absolute;
  left: 17px !important;
  font-size: 18px !important;
  top: 7px !important;
}
</style>
